// Shared fetch helper for the authenticated admin endpoints on
// artist-connect-api. Curried with a `firebase` instance so callers can pass
// `firebase` from the `withFirebase` HOC without leaking auth concerns into
// component code.
//
// API base resolves from REACT_APP_API_URL.

const API_BASE = process.env.REACT_APP_API_URL;

const getToken = async (firebase) => {
  const user = firebase.auth.currentUser;
  if (!user) throw new Error('Not authenticated');
  return user.getIdToken();
};

export const request = async (firebase, path, options = {}) => {
  const token = await getToken(firebase);
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  const text = await res.text();
  let body = {};
  if (text) {
    try {
      body = JSON.parse(text);
    } catch (parseErr) {
      // Non-JSON response body (e.g., Heroku H12, nginx 502 plain text).
      // Preserve the raw text so it surfaces through the error path below.
      body = { error: text };
    }
  }
  if (!res.ok) {
    const message = body && body.error ? body.error : `HTTP ${res.status}`;
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }
  return body;
};
